import React, { useEffect, useState } from 'react';
import InvoicesService from '../Services/InvoicesService';
import LocalService from '../Services/LocalService';
import { useToasts } from 'react-toast-notifications';
import AuthService from '../Services/AuthService';
import { Row, Col, Button, Input, Card, CardBody, FormGroup, Label, ButtonGroup} from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTranslation, t } from 'react-multi-lang';
import { Table , Tr, Td, Thead, Tbody, Th } from 'react-super-responsive-table';
import {
    faRefresh
} from "@fortawesome/free-solid-svg-icons";
import VolumesService from '../Services/VolumesService';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { StockService } from '../Services/StockService';
import { debounce } from 'lodash';
import Select from 'react-select';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';


const SalesStock = ({t}) => {
    const [config, setConfig] = useState({});
    const [stock, setStock] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [search, setSearch] = useState({});
    const [searchValues, setSearchValues] = useState({});
    const [textFilters, setTextFilters] = useState([]);
    const [listFilters, setListFilters] = useState([]);
    const authService = new AuthService();
    const stockService = new StockService();
    const { addToast } = useToasts();
    const [lots, setLots] = useState([]);
    const [volume, setVolume] = useState('');
    const fields = stockService.fields;

    useEffect(() => {
        setConfig(authService.getConfig());
        initialize();
    }, []);

    const setCurrentVolume = (vc) => {
        setVolume(vc);
        stockService.getLots(vc).then(lots => setLots(lots));
    }

    const getFilters = () =>{
        stockService.getSearchValues().then(sv => setSearchValues(sv));
    };

    const getStock = debounce(() => {
        stockService.searchStock(search, page, perPage).then(r => {
            setStock(r[0]);
            setTotalCount(r[1]);
        });
    }, 500);

    const initialize = () => {
        setListFilters(stockService.listFilters);
        setTextFilters(stockService.textFilters);
        getFilters();
        getStock();
    };

    const searchStock = () => {
        setPage(1);
        getStock();
    };

    useState(() => {
        setPage(1);
        getStock();
    }, [perPage]);

    const changePerPage = (pp) => {
        setPerPage(pp);
        setPage(1);
        getStock();
    }

    const changePage = (page) => {
        setPage(page);
        console.log(page);
        getStock();
    }

    const calculatePages = () => {
        let pages = [];
        let totalPages = Math.ceil(totalCount / perPage);
        for(let i = 1; i <= totalPages; i++){
            pages.push(i);
        }
        return pages;
    }
    
    return  <Card style={{padding: '20px'}}>
            <CardBody>
                <h3>{t('sideBar.stock')}</h3>
                <Row style={{background: '#eee', padding: '15px', borderRadius: '8px'}}>
                    <Col md="11">
                        <h5>Αναζήτηση</h5>
                        <Row>
                        {
                            fields.map((f, i) => {
                                if(textFilters.includes(f.code)){
                                    return <Col md="3" key={f.code}>
                                        <Label>{f.name}</Label>
                                        <Select options={[{label: `Επιλέξτε ${f.name}`, value: ''}, ...(searchValues[f.code] ? searchValues[f.code].reduce((values, v) => {
                                            values.push({value: v, label: v});
                                            return values;
                                        }, []) : [])] } onChange={(e) => setSearch({...search, [f.code]: e.value})} />
                                    </Col>
                                }
                                else if(listFilters.includes(f.code)){
                                    return <Col md="3" key={f.code}>
                                        <Label>{f.name}</Label>
                                        <Select isMulti options={[{label: `Επιλέξτε ${f.name}`, value: ''}, ...(searchValues[f.code] ? searchValues[f.code].reduce((values, v) => {
                                            values.push({value: v, label: v});
                                            return values;
                                        }, []): [])]} onChange={(e) => {
                                                console.log(e.values());
                                                setSearch({...search, [f.code]: Array.from(e.values())
                                                })
                                                console.log(search);
                                         }} />
                                    </Col>
                                }
                                else{
                                    return <Col md="3" key={f.code}>
                                        <Label>{f.name}</Label>
                                        <Input type="text" onChange={(e) => setSearch({...search, [f.code]: e.target.value})} />
                                    </Col>
                                }
                            })
                        }
                        </Row>
                    </Col>
                    <Col md="1" className="d-grid">
                        <Button color="primary" size="sm" onClick={searchStock}><FontAwesomeIcon icon={faRefresh} /></Button>
                    </Col>
                    <Col md="12">
                        <hr />
                    </Col>
                    <Col md="6">
                        <Label>Εγγραφές Ανά Σελίδα</Label>
                        <Input type="select" onChange={(e) => changePerPage(parseInt(e.target.value))}>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                        </Input>
                    </Col>
                    <Col md="6" className="d-grid">
                        <ReactHTMLTableToExcel
                            id="unassessedButton"
                            className="btn btn-sm btn-success btn-block"
                            table="stockTable"
                            filename="stock"
                            sheet="volumes"
                            buttonText="Excel"/>
                    </Col>
                </Row>
                <hr />
                <Table id="stockTable">
                    <Thead>
                        <Tr>
                            {
                                fields.map((f, i) => {
                                    return <Th key={i}>{f.name}</Th>
                                })
                            }
                        </Tr>
                    </Thead>
                    <Tbody>
                    {
                        stock.map(v => {
                            return <><Tr style={{ background: v.StringField4 === volume ? '#fefefe' : '#fff', borderBottom: '1px solid #aaa' }} onClick={() => setCurrentVolume(v.StringField4)} key={v.GID} >
                                {
                                    fields.map((f, index) => {
                                        return <Td style={{padding: '5px'}} key={v.GID + '-' + (index.toString())}>{v[f.code]}</Td>
                                    })
                                }
                            </Tr>
                            {
                                volume === v.StringField4 && <><Tr style={{background: '#f4f4f4'}}>
                                        <Th>Παρτίδα</Th>
                                        <Th>Οικογένεια</Th>
                                        <Th>Ομάδα</Th>
                                        <Th>Μήκος</Th>
                                        <Th>Πλάτος</Th>
                                        <Th>Πλάκες</Th>
                                        <Th>Αριθμός Τεμαχίων</Th>
                                        <Th>Ποσότητα</Th>
                                    </Tr>
                                    {
                                        lots && lots.map(l => <Tr key={l.GID} style={{background: '#f4f4f4'}}>
                                            <Td>{l.LotCode}</Td>
                                            <Td>{l.Oikogeneia}</Td>
                                            <Td>{l.Omada}</Td>
                                            <Td>{l.LotLength}</Td>
                                            <Td>{l.LotWidth}</Td>
                                            <Td>{l.Arithmisi_Plakon}</Td>
                                            <Td>{l.tem_input}</Td>
                                            <Td>{l.Balance} {l.MeasurementUnit}</Td>
                                        </Tr>)
                                    }
                                </>
                            }
                            </>
                        })
                    }
                    </Tbody>
                </Table>
                <ButtonGroup>
                    { calculatePages().filter(p => p > page - 5 && p < page + 5).map(p => <Button key={p} color={p === page ? 'light' : 'secondary'} onClick={() => changePage(p)} >{p}</Button>) }
                </ButtonGroup>
        </CardBody>
    </Card>
};

export default withTranslation(SalesStock);